import React from 'react'
import {
  Box,
  CircularProgress,
  IconButton,
  IconButtonClassKey,
  SvgIcon,
  Tooltip,
} from '@material-ui/core'
import { ClassNameMap } from '@material-ui/core/styles/withStyles'
import ReactPDF from '@react-pdf/renderer'

export type TProps = {
  src?: string
  pdf: ReactPDF.UsePDFInstance
  title: string
  showDownloadButton: boolean
  loading?: boolean
  buttonClasses?: Partial<ClassNameMap<IconButtonClassKey>>
  onDownload?: () => void | Promise<void>
  iframeStyle?: React.CSSProperties
}

export const PDFViewer = ({
  loading = false,
  pdf,
  src,
  showDownloadButton,
  buttonClasses,
  onDownload,
  title,
  iframeStyle,
}: TProps): JSX.Element | null => {
  if (pdf.loading || pdf.error !== null || pdf.blob === null) {
    return null
  }

  return (
    <Box
      display='flex'
      flex={1}
      position='relative'
    >
      {showDownloadButton && (
        <Box
          position='absolute'
          bottom='20px'
          right='40px'
        >
          <Tooltip title='Download ZIP'>
            {loading ? (
              <CircularProgress
                style={{
                  color: 'white',
                }}
              />
            ) : (
              <IconButton
                classes={buttonClasses}
                size='medium'
                onClick={() => {
                  void onDownload?.()
                }}
                aria-label='upload picture'
                component='span'
              >
                <SvgIcon htmlColor='white'>
                  <path d='M20 6h-8l-2-2H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V8c0-1.1-.9-2-2-2zm-2 6h-2v2h2v2h-2v2h-2v-2h2v-2h-2v-2h2v-2h-2V8h2v2h2v2z'></path>
                </SvgIcon>
              </IconButton>
            )}
          </Tooltip>
        </Box>
      )}
      <iframe
        src={src}
        title={title}
        style={{
          flex: 1,
          height: '100vh',
          ...iframeStyle,
        }}
      />
    </Box>
  )
}

export default PDFViewer
